<div class="container-fluid py-5">
  <!-- Title and Subtitle -->
  <div *ngIf="showTitles" class="container">
    <div class="row">
      <div class="col-12">
        <div
          class="titleTextFont font-weight-normal"
          style="font-size: 2.4rem"
          [ngClass]="{ 'cursor-pointer': hasTitleLink() }"
          (click)="gotToLink()"
        >{{ title }}</div>
      </div>
      <div *ngIf="subtitleText" class="col-12">
        <div
          class="font-weight-normal fadeIn mb-3 subtitle-block"
          style="font-size: 1.5rem"
        >{{ subtitleText }}</div>
      </div>
    </div>
  </div>

  <!-- Cards Slider -->
  <div *ngIf="cards && cards.length > 0" class="cards-slider">
    <div class="slider-wrapper">
      <div
        class="slider-track"
        [style.transform]="getTransform()"
      >
        <div
          *ngFor="let card of cards; let i = index"
          class="card-slide"
          [class.active]="i === currentIndex"
        >
          <div class="custom-card" (mouseenter)="isHovered = true" (mouseleave)="isHovered = false">
            <!-- Image Section (full width, 640x370 ratio) -->
            <div class="card-image-section">
              <div class="card-image">
                <img
                  [src]="getImage(card)"
                  [alt]="card.title"
                  loading="lazy"
                />
              </div>
            </div>

            <!-- Content Section -->
            <div class="card-content-section">
              <h3 class="card-title">{{ card.title }}</h3>
              <p
                class="card-description"
                [class.expanded]="isExpanded(i)"
              >{{ card.description }}</p>
              <a
                *ngIf="isOverflowing(i) || isExpanded(i)"
                class="card-read-more"
                href="#"
                (click)="toggleExpand(i, $event)"
              >
                {{ isExpanded(i) ? 'Ver menos' : 'Ver mas' }}
              </a>

              <!-- Button -->
              <div *ngIf="card.url" class="card-button-wrapper">
                <a
                  [href]="card.url"
                  class="card-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ card.button_text || '' }}
                  <i class="fa fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Arrows -->
    <div class="slider-controls">
      <button
        class="nav-arrow prev"
        (click)="prevSlide()"
        [style.border-color]="primaryColor"
        [style.color]="primaryColor"
      >
        <i class="fa fa-chevron-left"></i>
      </button>

      <!-- Dots Indicator -->
      <div class="dots-indicator">
        <span
          *ngFor="let card of cards; let i = index"
          class="dot"
          [class.active]="i === currentIndex"
          [style.background-color]="i === currentIndex ? primaryColor : '#d1d5db'"
          (click)="goToSlide(i)"
        ></span>
      </div>

      <button
        class="nav-arrow next"
        (click)="nextSlide()"
        [style.border-color]="primaryColor"
        [style.color]="primaryColor"
      >
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
  </div>

  <!-- Buttons -->
  <div class="row mt-4 align-center">
    <a
      href="#"
      target="_self"
      class="btn btn-info btn-flex m-2 col-auto"
    >
      Ver todos los programas
    </a>
  </div>
</div>
